// @flow

import React, { Component } from 'react';
import glamorous from 'glamorous';
import colorUtils from 'color';
import getGlobalLeaderboardColor from 'app/utils/getGlobalLeaderboardColor';
import ProgressiveRenderList from 'app/components/commons/ProgressiveRenderList';
import theme from 'app/theme';
import Icon from 'app/components/commons/Icon';
import LeaderboardRow from './LeaderboardRow';

type Props = {
  displayCountry: boolean,
  entries: Array<Object>,
  highestScore: number,
  lowScore: number,
  spartan: boolean,
};

type State = {
  openRow: ?number,
};

const LeaderboardListDiv = glamorous.div(props => ({
  position: 'relative',
  backgroundColor: colorUtils(props.theme.color.panel)
    .alpha(0.7)
    .string(),
}));

const IconContainer = glamorous.div({
  position: 'absolute',
  top: 0,
  right: 0,
  pointerEvents: 'none',
});

const StyledIcon = glamorous(Icon)({
  width: 350,
  height: 350,
  color: 'white',
  opacity: 0.1,
});

class LeaderboardList extends Component<Props, State> {
  props: Props;
  state: State = {
    openRow: null,
  };

  toggleRow = (id: number) => {
    this.setState(state => ({
      openRow: state.openRow === id ? null : id,
    }));
  };

  renderItem = (index: number) => {
    const { displayCountry, entries, highestScore, lowScore, spartan } = this.props;
    const entry = entries[index];
    const { openRow } = this.state;
    return (
      <LeaderboardRow
        key={entry.userId}
        avatar={entry.userAvatar}
        color={
          spartan && index < 5
            ? theme.color.spartanBlue
            : getGlobalLeaderboardColor(index, entries.length)
        }
        countryName={entry.countryName}
        delay={0.2 + index * 0.03}
        displayCountry={displayCountry}
        flagImage={entry.countryFlag}
        globalScore={entry.globalScore}
        highestScore={highestScore}
        id={entry.userId}
        isOpen={openRow === entry.userId}
        isUltimateChampion={entry.position === 1}
        isVIP={entry.isVIP}
        lowScore={lowScore}
        name={entry.userName}
        onClick={this.toggleRow}
        originalEntries={entry.originalEntries}
        rank={entry.position}
        prize={entry.prize}
      />
    );
  };

  render() {
    const { entries, spartan } = this.props;
    const { openRow } = this.state;
    return (
      <LeaderboardListDiv>
        <ProgressiveRenderList
          itemRenderer={this.renderItem}
          length={entries.length}
          initialAmount={10}
          progressiveAmount={20}
          openRow={openRow} // force PureComponent update
        />
        {spartan && (
          <IconContainer>
            <StyledIcon type="icon-spartan" />
          </IconContainer>
        )}
      </LeaderboardListDiv>
    );
  }
}

export default LeaderboardList;
